export default __webpack_public_path__ + "media/images/qr/small_business_line-9041451365f427df9b9f2f51ebdb3ac4.png";